/** @format */
import { QUERY_KEYS } from "../../constant/queryKeys.constant";
import { queryKeys } from "../queryKeys";
import createQuery from "src/api/create-query.js";

//get company by id
export const useGetCompanyByID = createQuery({
  url: ({ company_id }) => `/company/${company_id}`,
  queryKey: (_, { company_id }) =>
    queryKeys[QUERY_KEYS.company].getCompanyByID(company_id).queryKey,
});

//get company accounts by company id
export const useGetCompanyAccountsByCompanyID = createQuery({
  url: ({ company_id }) => `/company/${company_id}/accounts`,
  method: "GET",
});

//get company accounts by user id
export const useGetCompanyAccountsByUserID = createQuery({
  url: (user_id) => `/company/accounts/user/${user_id}`,
  method: "GET",
});

//get company me
export const useGetCompanyMe = createQuery({
  url: "/company/me",
  method: "GET",
});

//get company accounts me
export const useGetCompanyAccountsMe = createQuery({
  url: "/company/me/accounts",
  method: "GET",
});

//get company plan me
export const useGetCompanyPlanMe = createQuery({
  url: "/company/plan/me",
  method: "GET",
});

//get company subscription me
export const useGetCompanySubscriptionMe = createQuery({
  url: "/company/subscription/me",
  method: "GET",
});
